import React, { Component } from 'react';
import { globalData } from 'global/js/globalData';
import RadioButton from 'components/RadioButton/RadioButton';
import './RadioButtonList.scss';

const RadioButtonList = (props) => {
    /**
     * Constructs the list of star radio buttons used for customer feedback.
     * One button for each possible star value.
     */
    const buildRadioButtons = () => {
        const answerTypes = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10];
        
        return answerTypes.map((answer, index) => {
            const ratingId = 'rating' + index;

            return (
                <RadioButton
                    htmlFor={ratingId}
                    isChecked={props.answerValue === answer}
                    key={ratingId}
                    onChange={handleChange}
                    radioButtonId={ratingId}
                    ratingLabel={index}
                    value={answer}
                />
            );
        });
    };

    /**
     * Called when a star input value is clicked. This function gets the
     * value attribute of the star/input and sets the state with it.
     */
    const handleChange = (event) => {
        props.handleClick({
            type: props.questionType,
            rating: parseInt(event.target.value)
        });
    };

    return (
        <section className='ratings'>
            <div className='ratings__helper__wrapper'>
                <span className='ratings__helper-text'>{globalData.ratingHelperLow}</span>
                <span className='ratings__helper-text'>{globalData.ratingHelperHigh}</span>
            </div>
            <div className='ratings__wrapper'>
                {buildRadioButtons()}
            </div>
        </section>
    );
};

export default RadioButtonList;



// WEBPACK FOOTER //
// ./application/components/RadioButtonList/RadioButtonList.jsx